import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelect } from '@angular/material';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/subsidiary-contract.service';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { SubsidiaryCompanyAgentService } from 'src/app/services/http/business/subsidiary/subsidiary-company-agent.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-subsidiary-contract-entry',
  templateUrl: './subsidiary-contract-entry.component.html',
  styleUrls: ['./subsidiary-contract-entry.component.css']
})
export class SubsidiaryContractEntryComponent implements OnInit {
  form: FormGroup;
  customers = [];

  errors = new Array();
  errObject: any;
  param: string[];
  errorList: IError[] = [];
  customer: any;
  customerAgents: any;
  showSearch: boolean = true;
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private subsidiaryCompanyAgentService: SubsidiaryCompanyAgentService,
    public translate: TranslateService,
    private subsidiaryContractService: SubsidiaryContractService,
    private subsidiaryCompanyService: SubsidiaryCompanyService,
    private dialogRef: MatDialogRef<SubsidiaryContractEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {

    this.formControl();
    if (this.data.CustomerId) {
      this.showSearch = false;
      this.getContractById()
    } else
      this.getCustomerList();
    this.getCustomerAgent();
  }

  getCustomerList() {
    this.subsidiaryCompanyService.getCustomerListCombo().subscribe(res => {
      this.customers = res;
    });
  }


  formControl() {
    this.form = this.fb.group({
      Id: [this.data && this.data["Id"] ? this.data["Id"] : 0],
      Title: [
        this.data && this.data["Title"] ? this.data["Title"] : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(70),
          Validators.minLength(2)
        ])
      ],

      Coefficient: [
        this.data && this.data["Coefficient"]
          ? this.data["Coefficient"]
          : 0,
        Validators.compose([
          Validators.min(0),
          Validators.max(6)
        ])
      ],

      ContractNumber: [
        this.data && this.data["ContractNumber"]
          ? this.data["ContractNumber"]
          : null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(20),
          Validators.pattern("([0-9]{1,20})")
        ])
      ],

      CustomerAgentId: [null,
        Validators.compose([
          Validators.required
        ])
      ],

      ContractNumberAttachment: [
        this.data && this.data["ContractNumberAttachment"]
          ? this.data["ContractNumberAttachment"].toString()
          : null,
        Validators.compose([
          Validators.minLength(0),
          Validators.maxLength(40)
        ])
      ],

      ContractDate: [
        this.data && this.data["ContractDate"] ?
          this.data["ContractDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],
      StartDate: [
        this.data && this.data["StartDate"] ?
          this.data["StartDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],
      EndDate: [
        this.data && this.data["EndDate"] ?
          this.data["EndDate"] : null,
        Validators.compose([
          Validators.required
        ])
      ],

      Explain: [
        this.data && this.data["Explain"]
          ? this.data["Explain"].toString()
          : null
      ],

    });
    if (this.data.CustomerAgentId)
      this.form.controls['CustomerAgentId'].patchValue(this.data.CustomerAgentId.toString());
  }

  getCustomerAgent() {
    let queryParams = {
      CustomerId: this.data.CustomerId
    };
    this.subsidiaryCompanyAgentService.getCustomerAgentList(queryParams).subscribe(
      res => {
        this.customerAgents = res.DataList;
      }
    );
  }
  setFilter(event: MatSelect) {
    this.data = {
      CustomerId: event.value
    }
    this.showSearch = false;
    this.getContractById();
  }
  getContractById() {
    let queryParams = {
      Id: this.data.CustomerId
    };
    this.subsidiaryCompanyService.getCustomerList(queryParams).subscribe(
      res => {

        this.customer = res.DataList[0];
      }
    );
  }

  submit(form: any) {

    this.errors = new Array();
    if (form.ContractDate && form.StartDate) {
      form.ContractDate = moment
        .from(form.ContractDate, "en")
        .utc(true)
        .format(environment.dateFormat);

      form.StartDate = moment
        .from(form.StartDate, "en")
        .utc(true)
        .format(environment.dateFormat);

      form.EndDate = moment
        .from(form.EndDate, "en")
        .utc(true)
        .format(environment.dateFormat);
    } else {
      form.StartDate = null;
      form.EndDate = null;
    }
    form["CustomerId"] = this.data.CustomerId;
    if (this.data && this.data.Id) {
      this.subsidiaryContractService.customerContractEdit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    } else {
      this.subsidiaryContractService.customerContractAdd(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error)
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
